import Vue from 'vue'
import Vuelidate from 'vuelidate'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/style/css/style.css'

Vue.use(Vuelidate)

Vue.config.productionTip = false

new Vue({
  data: () => ({
    signedUp: false,
    registered: false,
    msg: ''
  }),
  router,
  store,
  render: h => h(App)
}).$mount('#app')
